declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
    cookieconsent: any;
  }
}

const GA_TRACKING_ID = "G-N374DRYN4J";

export const initGA = () => {
  window.dataLayer = window.dataLayer || [];
  // Must use arguments object (not rest params) — GA's dataLayer parser requires it
  window.gtag = function () {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  };

  // Default to granted — users can opt out via the cookie banner
  window.gtag("consent", "default", {
    analytics_storage: "granted",
    ad_storage: "denied",
  });

  window.gtag("js", new Date());
  window.gtag("config", GA_TRACKING_ID);

  const gaScript = document.createElement("script");
  gaScript.async = true;
  gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`;
  document.head.appendChild(gaScript);

  // Load TermsFeed cookie consent banner
  const cookieScript = document.createElement("script");
  cookieScript.type = "text/javascript";
  cookieScript.src =
    "https://www.termsfeed.com/public/cookie-consent/4.2.0/cookie-consent.js";
  cookieScript.setAttribute("charset", "UTF-8");
  document.head.appendChild(cookieScript);

  cookieScript.onload = () => {
    if (!window.cookieconsent) return;

    window.cookieconsent.run({
      notice_banner_type: "simple",
      consent_type: "express",
      palette: "light",
      language: "en",
      page_load_consent_levels: ["strictly-necessary"],
      notice_banner_reject_button_hide: false,
      preferences_center_close_button_hide: false,
      page_refresh_confirmation_buttons: false,
      website_name: "ariadnesgallery.com",
    });

    // Revoke analytics if user explicitly rejects
    window.addEventListener("cookie_consent_update", () => {
      try {
        const levels =
          window.cookieconsent.cookieConsentObject.consentType.cookieConsent
            .userConsent.acceptedLevels;
        if (!levels.tracking) {
          window.gtag("consent", "update", { analytics_storage: "denied" });
        }
      } catch {
        // ignore
      }
    });
  };
};

export const trackPageView = (url: string) => {
  if (typeof window === "undefined" || !window.gtag) return;
  window.gtag("config", GA_TRACKING_ID, { page_path: url });
};

export const trackEvent = (
  action: string,
  category?: string,
  label?: string,
  value?: number
) => {
  if (typeof window === "undefined" || !window.gtag) return;
  window.gtag("event", action, {
    event_category: category,
    event_label: label,
    value,
  });
};
